export enum PickupOrderStatus {
  Pending = 'pending',
  FalseBarcode = 'false_barcode',
  Picked = 'picked',
  Processed = 'processed',
  Cancelled = 'cancelled',
}

export enum PickupOrderCancelReason {
  PayOnPickup = 'payOnPickup',
}

export interface PickupOrder {
  id: string
  userId: string
  pickupDate: string
  orderNumber: string
  barcodeImg: string
  warehouse: string
  status: PickupOrderStatus
  pkgCount?: number
  cancelReason?: PickupOrderCancelReason
  createdAt: string
}
export interface PickupOrderWithUser extends PickupOrder {
  userName: string
  userEmail: string
  userPhone: string
}

export interface CreatePickupOrderPayload {
  pickupDate: string
  orderNumber: string
  barcodeFile: File | null
}
